module.exports = __webpack_public_path__ + "img/launch.5b12db9b.svg";